export const brandLogoGreenAsset = '';
export const rivelinBackgroundGraphicAsset = '';
export const heroPoweredByNetshapeAsset = '';
export const brandLogoLightAsset = 'https://images.ctfassets.net/bjia12x471fb/21fBJzMp8S1LOhqD1y1l2N/f5f6314d7ec6c2da38317f8dbad37800/rivelin_logo-idevice_gr-lgt_4x.png';
export const brandWordmarkAsset = 'https://images.ctfassets.net/bjia12x471fb/5I3OIMUqV1G3lXISdaq33c/33ec06355d216ac1307f97c30e904332/rivelin_logos_rivelin_logo-idevice_gr-drk_4x.png';
export const defaultVideoLoadingLogoAsset = brandLogoLightAsset;
